import Rotulo from "./Rotulo.vue";
import BadgeStatus from "./BadgeStatus.vue";
import RssReader from "./RssReader.vue";

export const HcRotulo = Rotulo;

export const HcBadgeStatus = BadgeStatus;
export const HcRssReader = RssReader;
